export const READ_ALL_SERVICES_SUCCESS = '@@services/READ_ALL_SERVICES_SUCCESS';
